import React, { useEffect, useState } from "react";
import { Row, Col, Card, Typography, Button, Spin, message } from "antd";
import { getCompanie } from "../../Api/Apis";
import AppConfig from "../config/AppConfig";
import { Link } from "react-router-dom";
const { Title, Text } = Typography;

const MatchedCompanies = ({ formData, gotoPayment }) => {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
  const fetchCompanies = async () => {
    setLoading(true);
    try {
      const raw = localStorage.getItem("BusinessQuestionnaireId");
      const questionnaireId = raw ? JSON.parse(raw) : null;

      if (!questionnaireId) {
        message.error("We couldn't find your request. Please re-submit the form.");
        setCompanies([]);
        return;
      }

      const res = await getCompanie(AppConfig["entityNames"]["getCompanies"], questionnaireId);

      if (res?.success && Array.isArray(res.data)) {
        setCompanies(res.data);
      } else {
          setCompanies([]);
        message.error("Failed to fetch matched companies.");
      }
    } catch (e) {
      console.error("Error fetching companies:", e);
      message.error("Something went wrong while fetching matches.");
        setCompanies([]);
    } finally {
      setLoading(false);
    }
  };

  fetchCompanies();
}, []);


  const handleGoToPayment = () => {
    gotoPayment();
  };

  const fixDash = (s) => (s || "").replace(/-/g, "-");

  const blurredStyle = {
    filter: "blur(6px)",
    pointerEvents: "none",
    userSelect: "none",
  };
  const overlayStyle = {
    position: "absolute",
    top: 12,
    left: 12,
    right: 12,
    textAlign: "center",
    color: "#fff",
    fontWeight: 600,
    background: "rgba(0,0,0,0.55)",
    padding: "6px 10px",
    borderRadius: 8,
    zIndex: 2,
    fontSize: 12,
  };
  const cardContentWrapper = { position: "relative", minHeight: 120 };

  return (
    <Spin spinning={loading}>
      <Row justify="center" style={{ marginTop: 40 }}>
        <Col xs={24} sm={20} md={16} lg={14} xl={12} xxl={24}>
          <Card style={{ borderRadius: 12, textAlign: "center" }}>
            <Title level={2} style={{ textAlign: "center" }}>
              Thank you for completing the needs analysis form!
            </Title>
            <Text type="secondary" style={{ display: "block", textAlign: "center", marginBottom: 20 }}>
              {`We matched your answers with ${companies.length} ${companies.length === 1 ? "company" : "companies"} that can help your business.`}
            </Text>

            <Row gutter={[16, 16]} justify="center" style={{ marginTop: 30 }}>
              <Col span={8}>
                <Card bordered={false}>
                  <Text strong>Industry:</Text>
                  <div>{Array.isArray(companies[0]?.industry) ? companies[0].industry.join(", ") : (companies[0]?.industry || "—")}</div>
                </Card>
              </Col>
              <Col span={8}>
                <Card bordered={false}>
                  <Text strong>Age Groups:</Text>
                  <div>{Array.isArray(companies[0]?.ageGroup) ? companies[0].ageGroup.map(fixDash).join(", ") : (companies[0]?.ageGroup || "—")}</div>
                </Card>
              </Col>
              <Col span={8}>
                <Card bordered={false}>
                  <Text strong>Budget:</Text>
                  <div>{Array.isArray(companies[0]?.ranges) ? companies[0].ranges.join(", ") : (companies[0]?.ranges || "—")}</div>
                </Card>
              </Col>
            </Row>

            <div style={{ marginTop: 30, textAlign: "center" }}>
              {companies.length > 0 ? (
                <>                
                  <Text type="secondary">Please <Link to="/app/Contact">contact</Link> us with any questions.</Text>
                  <div>
                    <Button
                      type="primary"
                      size="large"
                      style={{ marginTop: 15, borderRadius: 20 }}
                      onClick={handleGoToPayment}
                    >
                      Proceed to Payment
                    </Button>
                  </div>                  
                </>
              ) : (
                <div style={{ marginTop: 10 }}>
                  <Text strong style={{ color: "red" }}>No Matches Found</Text>
                  <div style={{ marginTop: 8 }}>
                    <Text type="secondary">We didn't find any matching media partners right now. We'll notify you when more providers become available.</Text>
                  </div>
                </div>
              )}
            </div>
          </Card>

          {/* Company Cards */}
          <Row gutter={[16, 16]} style={{ marginTop: 30 }}>
            {companies.map((company, index) => (
              <Col span={12} key={index}>
                <Card title={company.businessName} bordered hoverable style={{ borderRadius: 10 }}>
                  <div style={cardContentWrapper}>
                    <div style={overlayStyle}>Media companies will contact you</div>

                    <div style={blurredStyle}>
                      <Text strong>Contact Person:</Text>
                      <div>{company.contactPerson || "—"}</div>

                      <Text strong style={{ display: "block", marginTop: 8 }}>Phone:</Text>
                      <div>{company.phoneNumber || "—"}</div>

                      <Text strong style={{ display: "block", marginTop: 8 }}>Email:</Text>
                      <div>{company.email || "—"}</div>

                      <div style={{ marginTop: 10 }}>
                        {Array.isArray(company.area) && company.area.map((area, idx) => (
                          <Button
                            key={idx}
                            size="small"
                            style={{
                              backgroundColor: "#1890ff",
                              color: "#fff",
                              marginRight: 6,
                              marginBottom: 6,
                              border: "none",
                              borderRadius: 12,
                            }}
                          >
                            {area}
                          </Button>
                        ))}
                      </div>
                    </div>
                  </div>
                </Card>
              </Col>
            ))}
          </Row>
        </Col>
      </Row>
    </Spin>
  );
};

export default MatchedCompanies;
